<script setup lang="ts">
import type AccountsMex from '@/components/user/account/BankAccounts/Mex.vue';

const { userMexBankAccountLoading } = storeToRefs(useUserDataStore());

const speiComponentRef = ref<InstanceType<typeof AccountsMex> | null>(null);

const selectedBankType = computed(() => {
  return speiComponentRef.value?.selectedBankType ?? '';
});

const selectedBankCode = computed(() => {
  return speiComponentRef.value?.selectedBankCode ?? '';
});

const selectedBankNumber = computed(() => {
  return speiComponentRef.value?.selectedBankNumber ?? '';
});

defineExpose({
  selectedBankType,
  selectedBankCode,
  selectedBankNumber,
});
</script>

<template>
  <div :class="$style.speiInfo">
    <BaseLoading
      class="!bg-bg-primary !absolute !rounded-none"
      :show="userMexBankAccountLoading"
    />

    <UserAccountBankAccountsMex
      ref="speiComponentRef"
      :show-save-button="false"
    />
  </div>
</template>

<style module lang="scss">
.speiInfo {
  @apply relative px-0.5;

  .myDoc {
    @apply mt-4 mb-2 text-xs text-primary font-medium;
  }
  .methodAlert {
    @apply text-warning text-xs mt-3;
  }
}
</style>
